<template>
  <label class="folders-select__row flex-col" :style="{ 'margin-left': margin + 'px' }">
    <template v-if="element.folder">
      <span class="folders-select__folder" @click="selected('folder', element.folder)">
        Папка: {{ element.folder.name }}
        <Checkbox :value="element.folder.checked" :disabled="true"></Checkbox>
      </span>
    </template>
    <template v-if="element.groupArray && element.groupArray.length">
      <label
        v-for="(group, groupIdx) in element.groupArray"
        :key="groupIdx + 'group' + group.id"
        class="folders-select__row -course-"
        @click="selected('group', group)"
      >
        <span class="folders-select__text">
          {{ group.name }}
          <Checkbox :value="group.checked" :disabled="true"></Checkbox>
        </span>
      </label>
    </template>
    <template v-if="element.childrenFolders && element.childrenFolders.length >= 1">
      <SelectItem
        v-for="(item, idx) in element.childrenFolders"
        :key="data.folder.id + item.folder.id"
        :data="item"
        :path="path"
        :full-data="fullData"
        :margin="margin + 15"
        @clearFolder="clearFolder"
        @click="clickSelected($event, idx)"
      ></SelectItem>
    </template>
  </label>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SelectItem',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    margin: {
      type: Number,
      default: 0
    },
    path: {},
    fullData: {}
  },
  data() {
    return {
      element: {},
      text: []
    };
  },
  watch: {
    data(val) {
      this.element = _.cloneDeep(val);
    }
  },
  mounted() {
    this.element = _.cloneDeep(this.data);
  },
  methods: {
    selected(type, elem) {
      elem.checked = !elem.checked;

      if (type === 'folder' && elem.checked) {
        if (this.element.groupArray) {
          for (let i = 0; i < this.element.groupArray.length; i++) {
            this.element.groupArray[i].checked = true;
            this.$store.dispatch(`${this.path}/incrementGroup`, this.element.groupArray[i]);
          }
        }

        if (this.element.childrenFolders) {
          for (let i = 0; i < this.element.childrenFolders.length; i++) {
            this.element.childrenFolders[i] = {
              ...this.reqFunction(this.element.childrenFolders[i])
            };
          }
        }
      }

      if (type === 'group' && !elem.checked) {
        this.element.folder.checked = false;

        this.findParentFolder(this.fullData);
        this.$store.dispatch(`${this.path}/dicrementGroup`, elem);
      } else if (type === 'group' && elem.checked) {
        this.$store.dispatch(`${this.path}/incrementGroup`, elem);
      }
      this.$emit('click', this.element);
    },
    reqFunction(data) {
      data.folder.checked = true;
      if (data.groupArray) {
        for (let i = 0; i < data.groupArray.length; i++) {
          data.groupArray[i].checked = true;
          this.$store.dispatch(`${this.path}/incrementGroup`, data.groupArray[i]);
        }
      }

      if (data.childrenFolders) {
        for (let i = 0; i < data.childrenFolders.length; i++) {
          data.childrenFolders[i] = {
            ...this.reqFunction(data.childrenFolders[i])
          };
        }
      }

      return data;
    },
    findParentFolder(data) {
      const self = this.element;

      function parentFolder(item) {
        const equal = item.findIndex(el => el.folder.id === self.folder.id);

        if (equal > -1) {
          return true;
        } else {
          for (let i = 0; i < item.length; i++) {
            const element = item[i].childrenFolders;
            if (element && element.length >= 1) {
              if (parentFolder(element)) {
                return true;
              } else {
                parentFolder(element);
              }
            }
          }
        }
      }
      if (parentFolder(data)) {
        this.$emit('clearFolder', false);
      }
    },
    clearFolder(value) {
      this.element.folder.checked = value;
    },
    clickSelected(value, idx) {
      const data = { ...this.element };
      data.childrenFolders[idx] = value;

      this.$emit('click', data);
    }
  }
};
</script>
